var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label)?_c('sn-label',{staticClass:"mb-2",attrs:{"title":_vm.label}}):_vm._e(),_vm._v(" "),_c('v-textarea',_vm._g(_vm._b({staticClass:"sn-textarea"},'v-textarea',_vm.vuetifyOverrideMixin.bindings,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }